import { searchConstants } from "../../_constants";

const initialState = {};

//login reducer
export const search_skill_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_SKILL_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_SKILL_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        skillSearchData: action.payload,
      };
    case searchConstants.SEARCH_SKILL_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_job_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_JOB_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_JOB_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        jobSearchData: action.payload,
      };
    case searchConstants.SEARCH_JOB_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_company_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_COMPANY_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_COMPANY_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        companySearchData: action.payload,
      };
    case searchConstants.SEARCH_COMPANY_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_event_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_EVENT_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_EVENT_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        eventSearchData: action.payload,
      };
    case searchConstants.SEARCH_EVENT_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_assessment_kit_user_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case searchConstants.SEARCH_ASSESSMENT_KIT_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_ASSESSMENT_KIT_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        assessmentKitSearchData: action.payload,
      };
    case searchConstants.SEARCH_ASSESSMENT_KIT_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_city_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_CITY_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_CITY_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        citySearchData: action.payload,
      };
    case searchConstants.SEARCH_CITY_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_country_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_COUNTRY_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_COUNTRY_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        countrySearchData: action.payload,
      };
    case searchConstants.SEARCH_COUNTRY_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_state_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_STATE_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_STATE_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        stateSearchData: action.payload,
      };
    case searchConstants.SEARCH_STATE_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_candidate_kanban_board_user_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case searchConstants.SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_SUCCESS:
      return {
        loggedIn: true,
        candidateKanbanSearchData: action.payload,
      };
    case searchConstants.SEARCH_CANDIDATE_KANBAN_BOARD_USER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

//search company reducer

export const search_company_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_COMPANY_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_COMPANY_ACTION_SUCCESS:
      return {
        loggedIn: true,
        searchCompanyData: action.payload,
      };
    case searchConstants.SEARCH_COMPANY_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const search_job_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_JOBS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_JOBS_ACTION_SUCCESS:
      return {
        jobSearchDataList: action.payload,
      };
    case searchConstants.SEARCH_JOBS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

//search candidate reducer

export const search_candidate_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_CANDIDATE_ACTION_SUCCESS:
      return {
        loggedIn: true,
        searchCandidateData: action.payload,
      };
    case searchConstants.SEARCH_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

//search candidate reducer

export const search_mentor_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.SEARCH_MENTOR_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.SEARCH_MENTOR_ACTION_SUCCESS:
      return {
        loggedIn: true,
        searchMentorData: action.payload,
      };
    case searchConstants.SEARCH_MENTOR_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

export const get_all_skills_reducer = (state = initialState, action) => {
  switch (action.type) {
    case searchConstants.GET_ALL_SKILLS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case searchConstants.GET_ALL_SKILLS_ACTION_SUCCESS:
      return {
        allSkillsData: action.payload,
      };
    case searchConstants.GET_ALL_SKILLS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};
